import React, { useEffect, useState } from 'react'
import Header from '../_components/common/Header'
import EachcmsUI from '../_components/UI/EachcmsUI'
import { useParams } from 'react-router-dom';

const Eachcms = ({ draft = false }) => {
    const { name } = useParams();

  return (
    <div className='page-main'>
        <Header name = {["Content Management",name]} />
        <EachcmsUI slug={name} draft={draft} />

    </div>
  )
}

export default Eachcms